















































































































import Vue from 'vue'
import { MaxQuantityPrice  } from '@/common/types/maxQuantityPrice'
import { ProductCategory } from '@/model/productCategory'

import SearchModal from '@/top/components/SearchModal.vue'
import ModalOverlay from '@/common/components/ModalOverlay.vue'
import NumberInput from '@/top/components/NumberInput.vue'

export default Vue.extend({
  name: 'SearchControl',
  components: {
    SearchModal,
    ModalOverlay,
    NumberInput
  },
  props: {
     productCategories: {
      type: Array as () => ProductCategory[],
      required: true
    },
    maxQuantityPrice: {
      type: Object as () => MaxQuantityPrice,
      required: true
    }
  },
  data(): {
    isModalVisible: boolean
    loadedState: {[key: string]: number[]}
    selectedCategories: number[]
    customClass: string,
    inputQuantity: number,
    inputMinPrice: number,
    inputMaxPrice: number,
    quantitySuggest: number[]
  } {
    return {
      isModalVisible: false,
      customClass: 'tp-ModalOverlay',
      loadedState: {
        categories: []
      },
      selectedCategories: [],
      inputQuantity: 0,
      inputMinPrice: 0,
      inputMaxPrice: 0,
      quantitySuggest: [50,100,500,1000,3000,10000]
    }
  },
  computed: {
    errorMinPrice(): boolean {
      return this.inputMaxPrice > 0 && this.inputMinPrice > 0 && (this.inputMinPrice > this.inputMaxPrice)
    },
    errorMaxPrice(): boolean {
      return  this.inputMinPrice > 0  && this.inputMaxPrice > 0 && (this.inputMaxPrice < this.inputMinPrice)
    },
    isFormValid(): boolean {
      return !this.errorMaxPrice && !this.errorMinPrice
    }
  },
  methods: {
    close() {
      this.isModalVisible = false
    },
    openModal() {
      this.isModalVisible = true
      this.selectedCategories = this.loadedState.categories.slice(0)
    },
    savingCategoriesState(payload: {[key: string]: number | number[]}) {
      Object.assign(this.loadedState,payload)
      this.isModalVisible = false
      this.goToSearchPage()
    },
    onClickCategory(payload: number) {
      if (this.selectedCategories.includes(payload)) {
        this.selectedCategories.splice(this.selectedCategories.indexOf(payload), 1)
      }
      else this.selectedCategories.push(payload)
    },
    updateCategories(payload: number[]) {
      this.selectedCategories = payload.slice(0)
    },
    setQuantity(quantity: number) {
      if (quantity > this.maxQuantityPrice.max_price) return
      this.inputQuantity = quantity
    },
    setMinPrice(price: number) {
      this.inputMinPrice = price
    },
    setMaxPrice(price: number) {
      this.inputMaxPrice = price
    },
    goToSearchPage() {
      const categories = this.loadedState.categories.length == this.productCategories.length ? '' : this.loadedState.categories?.join() || ''
      const inputMinPrice = this.inputMinPrice || 1
      const inputMaxPrice = this.inputMaxPrice || this.maxQuantityPrice.max_price
      const inputQuantity = this.inputQuantity || ''
      location.href = `/search?category=${categories}&max=${inputMaxPrice}&min=${inputMinPrice}&quantity=${inputQuantity}`
      this.inputQuantity = 0
      this.inputMinPrice = 0
      this.inputMaxPrice = 0
    }
  }
})
